import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseDataLanguage } from '@work4all/models/lib/Classes/BaseDataLanguage.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EditTableColumns } from '../../../containers/mask-overlays/mask-overlay/views/erp/components/tab-panels/positions/components/edit-table/types';
import { EditableEntityTable } from '../editable-entity-table/EditableEntityTable';

const LANGUAGE_DATA: BaseDataLanguage = {
  id: null,
  name: null,
};

const newEntryMandatoryFields: (keyof BaseDataLanguage)[] = ['name'];

export const LanguageTable = () => {
  const { t } = useTranslation();

  const cols = useMemo<EditTableColumns<BaseDataLanguage>[]>(
    () => [
      {
        Header: t('COMMON.NAME'),
        accessor: 'name',
        width: 300,
        type: 'text',
      },
    ],
    [t]
  );

  return (
    <EditableEntityTable<BaseDataLanguage>
      columns={cols}
      dataFields={LANGUAGE_DATA}
      entity={Entities.baseDataLanguage}
      idType="number"
      sortByField="name"
      newEntryMandatoryFields={newEntryMandatoryFields}
      dataProviderProps={{
        completeDataResponse: true,
      }}
      enableDelete
    />
  );
};
